import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  name: string;
  _type: string;
  option: null | string;
  risk_level: string;
  active: boolean;
}
export const useEditSICIndustry = () => {
  const { authHeader } = useAuth();

  return useMutation(({ params, id }: { params: Params; id: number }) => {
    return axios.put(
      `${env.verifyServiceUrl}individual/sic_industry_risk_level/${id}/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
